import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=1c182353"
import script from "./DetailForm.vue?vue&type=script&lang=ts"
export * from "./DetailForm.vue?vue&type=script&lang=ts"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=1c182353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports